export default __webpack_public_path__ + "static/media/facebook-pixel-image.7b267f81.svg";